import { withAsync } from '@helpcenter/with-async';
import { lazyForPaint } from 'react-loosely-lazy';

export const CsmRequestsListForHubs = withAsync({
    loader: lazyForPaint(() => import(/* webpackChunkName: "csm-hub-requests-list" */ './csm-hub-variants')),
});
